import { PlotlyComponent } from '../../../helper/plotly/plotly.component';
import { ElementRef } from '@angular/core';

export class GraphSelectorPackage {
  request: {};
  plotFramework: string;
  imageName: string;
  plotlyComponent: PlotlyComponent;
  chartElement: ElementRef;
  chartSize: number[];
  legendWidth: number;
  canvasElement: ElementRef;
}
